import React, { FC } from 'react'
import classNames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classNames.bind(css)

interface OwnProps {
  alignCenter?: boolean
  alignEnd?: boolean
  alignTop?: boolean
  fullHeight?: boolean
  fullWidth?: boolean
  justifyCenter?: boolean
  justifyEnd?: boolean
  justifySpaceBetween?: boolean
  responsiveJustifyCenter?: boolean
  responsiveVertical?: boolean
  spaceBetween?: boolean
  vertical?: boolean
  wrap?: boolean
  relative?: boolean
  columnSmall?: boolean
  column?: boolean
  children?: React.ReactNode
  gap?: number
  disable?: boolean
}

const Flex: FC<OwnProps> = ({
  alignCenter,
  alignEnd,
  alignTop,
  fullHeight,
  fullWidth,
  justifyCenter,
  justifyEnd,
  justifySpaceBetween,
  responsiveJustifyCenter,
  responsiveVertical,
  spaceBetween,
  vertical,
  wrap,
  relative,
  columnSmall,
  column,
  children,
  gap,
  disable,
}: OwnProps) => {
  if (disable) return <>{children}</>
  return (
    <div
      className={cx('container', {
        alignCenter,
        alignEnd,
        alignTop,
        fullHeight,
        fullWidth,
        justifyCenter,
        justifyEnd,
        justifySpaceBetween,
        responsiveJustifyCenter,
        responsiveVertical,
        spaceBetween,
        vertical,
        wrap,
        relative,
        columnSmall,
        column,
      })}
      style={{ gap: gap ? `${gap}px` : 'auto' }}
    >
      {children}
    </div>
  )
}

export default Flex
